import { Img } from "@/components/image";
import { cn } from "@/lib/utils";

/**
 * Catering logo framed the way the diet card shows it. Deliberately not a link:
 * it sits inside the button opening the diet info dialog.
 */
export const DietCardCateringLogo = ({
  name,
  imageUrl,
  size,
  className,
}: {
  name: string;
  imageUrl?: string;
  size: number;
  className?: string;
}) => (
  <span
    className={cn(
      "flex shrink-0 items-center justify-center overflow-hidden rounded-sm border border-brand-grey2-300 bg-white p-1.5",
      className,
    )}
    style={{ width: size, height: size }}
  >
    {imageUrl && (
      <Img
        alt={name}
        className="h-full w-full object-contain"
        height={size}
        src={imageUrl}
        width={size}
      />
    )}
  </span>
);
